<template>
  <el-dialog
    :title="$t('config.profile.title.mergeDialog')"
    :visible.sync="mergeTableVisible"
    width="70%"
    :close-on-click-modal="false"
  >
    <MergeDataTable
      v-model="resultData"
      :selected-list="selectedList"
      :result-template="resultTemplate"
      :header-list="headerList"
      id-header="id"
      @onMerge="onMergeProfile"
    />
    <!-- <div>{{ selectedList }}</div> -->

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small" @click="onMergeProfile">
          {{ $t('config.profile.common.agree') }}
        </button>
        <button
          class="btn primary small outline"
          @click="mergeTableVisible = false"
        >
          {{ $t('config.profile.common.cancel') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import MergeDataTable from '../../components/MergeDataTable.vue'
import { mergeTravellerProfileApi } from '@/api/configuration/profile/traveller'

export default {
  components: { MergeDataTable },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      mergeTableVisible: this.value,
      resultData: null,

      resultTemplate: {
        code: 0,
        sex: 1,
        birth: null,
        email: null,
        name: null,
        passport: null,
        state: null,
        city: null,
        position: null,
        job: null,
        back_image: null,
        front_image: null,
        last_name: null,
        first_name: null,
        greeting_text: null,
        phone_number: '',
        customer_level: 0,
        member_id: null,
        visa_place: null,
        visa_expired_date: null,
        id_card: null,
        id_issued_place: null,
        other_payper: null,
        nationality_id: 0,
        nation_id: 0,
        address_1: null,
        address_2: null,
        id_issued_date: null,
        zip_code: null,
        visa_type: null,
        visa_issue_place: null,
        visa_issue_date: null,
        purpose: null,
        exit_from: null,
        entry_gate_id: null,
        passport_type: null,
        entry_date_from: null,
        entry_date_to: null
      }
    }
  },

  computed: {
    headerList() {
      return [
        { text: this.$t('config.profile.field.profileCode'), value: 'id' },
        {
          text: this.$t('config.profile.field.front_image'),
          value: 'front_image'
        },
        {
          text: this.$t('config.profile.field.back_image'),
          value: 'back_image'
        },
        { text: this.$t('config.profile.field.vocative'), value: 'name' },
        { text: this.$t('config.profile.field.lastName'), value: 'last_name' },
        {
          text: this.$t('config.profile.field.firstName'),
          value: 'first_name'
        },
        { text: this.$t('config.profile.field.gender'), value: 'sex' },
        { text: this.$t('config.profile.field.birth'), value: 'birth' },
        // {
        //   text: this.$t('config.profile.field.greeting'),
        //   value: 'greeting_text'
        // },
        { text: this.$t('config.profile.field.email'), value: 'email' },
        { text: this.$t('config.profile.field.phone'), value: 'phone_number' },
        {
          text: this.$t('config.profile.field.customerLevel'),
          value: 'customer_level'
        },
        { text: this.$t('config.profile.field.memberId'), value: 'member_id' },
        { text: this.$t('config.profile.field.idCard'), value: 'id_card' },
        // {
        //   text: this.$t('config.profile.field.idCardIssuedDate'),
        //   value: 'id_issued_date'
        // },
        // {
        //   text: this.$t('config.profile.field.idCardIssuedPlace'),
        //   value: 'id_issued_place'
        // },
        {
          text: this.$t('config.profile.field.nationality'),
          value: 'nationality_id'
        },
        // { text: this.$t('config.profile.field.position'), value: 'position' },
        { text: this.$t('config.profile.field.address1'), value: 'address_1' },
        { text: this.$t('config.profile.field.address2'), value: 'address_2' }
        // { text: this.$t('config.profile.field.state'), value: 'state' },
        // { text: this.$t('config.profile.field.city'), value: 'city' },
        // { text: this.$t('config.profile.field.zipCode'), value: 'zip_code' },
        // { text: this.$t('config.profile.field.job'), value: 'job' }
      ]
    }
  },

  watch: {
    value(nv, ov) {
      this.mergeTableVisible = nv
    },
    mergeTableVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    }
  },

  mounted() {},

  methods: {
    onMergeProfile() {
      this.resultData = {
        ...this.resultData,
        id: this.selectedList[0].id,
        id_to_merge: this.selectedList
          .map((item, index) => {
            if (index === 0) return null
            else return item.id
          })
          .slice(1)
      }
      if (this.resultData) {
        // call api merge and refresh
        mergeTravellerProfileApi(this.resultData)
          .then(data => {
            if (!data.is_error) {
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${data.message}`)
              })

              // close dialog
              this.mergeTableVisible = false
              this.$emit('resetSearch')
            } else {
              throw new Error(data)
            }
          })
          .catch(error => {
            this.$message({
              message: error.response?.data?.message,
              type: 'error'
            })
          })
          .finally(() => {})
      }
    }
  }
}
</script>
